import { render, staticRenderFns } from "./OnneMenu.vue?vue&type=template&id=585cc270&scoped=true&"
import script from "./OnneMenu.vue?vue&type=script&lang=ts&"
export * from "./OnneMenu.vue?vue&type=script&lang=ts&"
import style0 from "./OnneMenu.vue?vue&type=style&index=0&id=585cc270&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585cc270",
  null
  
)

export default component.exports